import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import PricingCards from "@/components/PricingCards";
import { ArrowClockwise, SignOut } from "@phosphor-icons/react";

// Écran d'abonnement (ESN non abonnée) — le paiement débloque l'accès. Plus de trial.
export default function Subscribe() {
  const { user, logout, refresh } = useAuth();
  const navigate = useNavigate();

  const recheck = async () => {
    await refresh();
    toast.info("Statut actualisé.");
  };

  return (
    <div className="min-h-screen bg-bg relative z-10 flex items-center justify-center p-6" data-testid="subscribe-gate">
      <div className="w-full max-w-xl">
        <div className="mb-8 text-center"><Logo size="text-2xl" /></div>
        <div className="surface rounded-2xl p-8 sm:p-10">
          <div className="overline mb-2 !text-accent">Ne laissez plus vos consultants entre deux missions</div>
          <h1 className="font-display text-3xl font-bold mb-2" data-testid="subscribe-title">
            Abonnez-vous pour accéder à interKO
          </h1>
          <p className="text-muted text-sm leading-relaxed mb-6">
            Pour <span className="text-fg font-semibold">29 €/mois, sans engagement</span>, interKO vous aide à identifier
            les entreprises qui recherchent réellement les compétences de vos consultants et à trouver les bons
            interlocuteurs pour les contacter.
          </p>

          <PricingCards returnTo="/app" />

          <div className="flex items-center gap-3 mt-8 pt-6 border-t border-border">
            <button onClick={recheck} data-testid="subscribe-recheck-btn"
              className="flex items-center justify-center gap-2 bg-surface-2 border border-border text-fg px-5 py-2.5 rounded-md hover-lift text-sm">
              <ArrowClockwise size={15} weight="bold" /> Vérifier mon statut
            </button>
            <button onClick={() => { logout(); navigate("/"); }} data-testid="subscribe-logout-btn"
              className="flex items-center justify-center gap-2 border border-border text-muted hover:text-fg px-5 py-2.5 rounded-md hover-lift text-sm">
              <SignOut size={15} /> Déconnexion
            </button>
            <span className="ml-auto text-xs text-muted font-mono truncate">{user?.email}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
